import type { TenantConfig } from "./types";

/**
 * Default tenant configuration
 * Used as a base for all tenant configs and as fallback
 */
export const defaultConfig: TenantConfig = {
  id: "default",
  name: "Wint",
  branding: {
    logo: "/Images/wint-logo.png",
    logoSmall: "/Images/wint-logo-small.png",
    favicon: "/favicon.ico",
    primaryColor: "#037ffc",
    secondaryColor: "#1d2041",
    companyName: "Wint",
  },
  terminology: {
    line: "Line",
    lines: "Lines",
    cip: "CIP",
    alert: "Alert",
    alerts: "Alerts",
    object: "Object",
    objects: "Objects",
    recipe: "Recipe",
    freshWater: "Fresh Water",
    stepGroup: "Step Group",
  },
  features: {
    weeklyTrend: true,
    cipAnalytics: true,
    exportCsv: true,
    valveStatus: false,
    shiftReport: false,
    showHealthScore: true,
    showRecuperatedWater: true,
    showTargets: true,
  },
  defaults: {
    unitSystem: "metric",
    dateFormat: "MMM d, yyyy",
    dateTimeFormat: "MMM d, yyyy HH:mm",
    timezone: "UTC",
    refreshRate: 60000,
    pageSize: 10,
  },
  routes: {
    dashboard: true,
    cipAnalytics: true,
    weeklyTrend: true,
    settings: true,
    valveStatus: false,
    shiftReport: false,
  },
  unitLabels: {
    volume: "L",
    volumeLarge: "㎥",
    flowRate: "L/h",
    temperature: "°C",
    duration: "min",
  },
  conversionFactors: {
    litersToVolume: 1, // Liters stay as liters
    litersToVolumeLarge: 0.001, // Liters to cubic meters
    flowRateConversion: 1,
    temperatureConversion: (celsius: number) => celsius,
  },
};
